export default __webpack_public_path__ + "static/media/b-13.e8f8fc9e.png";